import React from 'react'
import styled from 'styled-components'
import { Spinner } from 'reactstrap'
import SelectDetailList from './SelectDetailList'
import InvoiceDetailTable from './InvoiceDetailTable'
import InvoiceHeader from './InvoiceHeader'
import { formatCurrency } from '../../../helpers'
import DetailList from './SelectDetailList/DetailList'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const passThrough = a => a
const tableMapping = [
  { label: 'Description', field: 'descr', format: passThrough },
  { label: 'Amount', field: 'amount', format: formatCurrency }
]

const InvoiceList = ({
  isLoggedIn,
  formData,
  handleInvoiceListAdd,
  handleInvoiceListRemove,
  handleInvoiceAmountChange,
  invoiceNumbers,
  loading,
  error
}) => {
  const mapInvoices = (invoice) => ({
    label: `${invoice.invoiceNum} ${invoice.description}`,
    data: invoice,
    headerComponent: (<InvoiceHeader {...{ handleInvoiceAmountChange }} />),
    detailComponent: (<InvoiceDetailTable {...{ tableMapping }} />)
  })

  if (loading) return <div><Spinner color='secondary' /> Loading invoices</div>
  if (error) return <div className='mb-4'>No invoices found</div>

  const selectionHeader = 'INVOICES TO PAY'
  return (
    <Container>
      <h3>Invoices</h3>
      {invoiceNumbers || formData.token
        ? (
          <DetailList
            label={selectionHeader}
            items={formData.invoices.map(mapInvoices)}
            noResultsText='NO INVOICES FOUND'
          />
          )
        : (
          <SelectDetailList
            defaultText='Select Invoice to Add'
            noResultsText='NO INVOICES SELECTED'
            selectionHeader={selectionHeader}
            addHandler={handleInvoiceListAdd}
            removeHandler={handleInvoiceListRemove}
            items={formData.invoices.map(mapInvoices)}
            selected={formData.selectedItems}
          />
          )}
    </Container>
  )
}

export default InvoiceList
